// extracted by mini-css-extract-plugin
export const wrapper = "Clients-module--wrapper--FUZuJ";
export const top = "Clients-module--top--2cy3h";
export const logosWrapper = "Clients-module--logosWrapper--3B7pT";
export const logos = "Clients-module--logos--2Xrii";